// extracted by mini-css-extract-plugin
module.exports = {"Root":"Ad3V5rx5+XzwSCnoWTB0Og=="};